import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Category, UserProfile } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { OauthHelper } from './oauth-helper.service';

@Injectable()
export class CategoryApi {
	private categoryRepo: string = "/api/events/v2/categories";

	constructor(private httpClient: HttpClient, private logger: Logger, private jwtHelper: JwtHelper, private oauthHelper: OauthHelper) {
	}

	public linkCategory(collectionUrl: string, categoryUrls: string[]) {
		return this.httpClient.putRef(collectionUrl, categoryUrls)
	}

	public getCategories(url: string): Observable<Category[]> {
		return this.httpClient.get(url)
				.map(response => response.json()._embedded.categories)
			.catch(this.handleError);
	}

	public deleteCategory(category: Category): Observable<{}> {
		if (!category._links) return Observable.empty();
		return this.httpClient.delete(category._links.deleteWithReference.href)
	}

	public updateCategory(category: Category): Observable<Category> {
		let body = JSON.stringify(category);
		return this.httpClient.put(category._links.self.href, body).map(
			response => category
		)
	}


	public createAndLinkCategory(eventReferenceUrl: string, category: Category): Observable<Category>  {
		let body = JSON.stringify(category);
		let  observable: Observable<Category> = this.httpClient.post(this.categoryRepo, body)
			.map(response => <Category>response.json())
			.flatMap((resultCategory) => {
				return this.httpClient.postRef(eventReferenceUrl, resultCategory._links.self.href).map(
					response => resultCategory
				);
			})
		return observable;
	}

	public createCategory(category: Category): Observable<Category>  {
		let body = JSON.stringify(category);
		let  observable: Observable<Category> = this.httpClient.post(this.categoryRepo, body)
			.map(response => <Category>response.json())
		return observable;
	}

	public findByUuid(categoryUuid: string): Observable<Category> {
		return this.httpClient.get(this.categoryRepo + "/search/findByUuid?uuid=" + categoryUuid)
			.map(response => <Category>response.json())
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/category-api.service.ts